export default __webpack_public_path__ + "static/media/환자용_건강데이터분석.a55b4f03.png";